export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StandardHeader.vue?vue&type=template&id=27e9bdf1&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/StandardHeader.vue?vue&type=template&id=27e9bdf1&scoped=true
// module id = 239
// module chunks = 0